var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 48,
    viewBox: "0 0 34 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report Icon",
    clipPath: "url(#clip0_722_6214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5267 4.36714V43.6319C33.5267 44.7936 32.5125 45.7354 31.2614 45.7354H2.26528C1.0142 45.7354 0 44.7936 0 43.6319V4.36714C0 3.20543 1.0142 2.26367 2.26528 2.26367H31.2614C32.5125 2.26367 33.5267 3.20543 33.5267 4.36714Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.4483 9.62403L21.4483 15.2602C21.4483 15.5562 21.1899 15.7962 20.8711 15.7962L12.6573 15.7962C12.3385 15.7962 12.0801 15.5562 12.0801 15.2602L12.0801 9.62402L21.4483 9.62403Z",
    fill: "#347AF0",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.6954 9.62408L11.8313 9.62407C11.2808 9.62407 11.0427 8.97654 11.4783 8.66398L16.1497 5.31224C16.5103 5.05353 17.0135 5.05347 17.3741 5.31209L22.0482 8.66389C22.484 8.97639 22.246 9.62408 21.6954 9.62408Z",
    fill: "#2C3642"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.8401 12.4199L15.6866 12.4199C15.4228 12.4199 15.209 12.6185 15.209 12.8634L15.209 15.7964L18.3177 15.7965L18.3177 12.8634C18.3177 12.6185 18.1039 12.4199 17.8401 12.4199Z",
    fill: "#2C3642"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.5784 40.6219C16.9641 40.6219 16.405 41.142 16.405 41.7129C16.4031 42.431 15.231 42.43 15.2354 41.7115C15.2382 40.5277 16.3145 39.5279 17.5861 39.5279C18.6995 39.5279 19.3472 40.3531 19.8672 41.0168C20.6137 41.9668 20.7082 41.7342 20.814 41.7982L20.9683 41.7659C21.8394 41.171 21.8357 38.9893 23.5923 38.9893C25.0977 38.9893 25.4228 40.7257 25.9811 40.9969L26.1173 41.1371L26.3164 41.0442L26.4726 40.9018C27.5389 39.0566 30.0336 39.1638 30.5548 40.0585C30.7492 40.3948 30.4432 40.8063 30.0272 40.8063C29.6851 40.8063 29.596 40.5233 28.9585 40.5233C28.4151 40.5233 27.9197 40.7441 27.6336 41.2216L27.6193 41.237L27.5784 41.3043C26.8938 42.4969 25.4858 42.6421 24.4124 40.8572C22.8564 38.3044 23.1388 42.568 21.0083 42.8618C19.0453 43.1261 18.9493 40.6219 17.5784 40.6219Z",
    fill: "#347AF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.0025 19.8246H3.52343C3.18499 19.8246 2.91113 19.57 2.91113 19.2561C2.91113 18.9421 3.18499 18.6875 3.52343 18.6875H30.0025C30.3409 18.6875 30.6148 18.9421 30.6148 19.2561C30.6148 19.57 30.3409 19.8246 30.0025 19.8246Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.0025 23.1989H3.52343C3.18499 23.1989 2.91113 22.9443 2.91113 22.6303C2.91113 22.3163 3.18499 22.0618 3.52343 22.0618H30.0025C30.3409 22.0618 30.6148 22.3163 30.6148 22.6303C30.6148 22.9443 30.3409 23.1989 30.0025 23.1989Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M30.0025 26.5727H3.52343C3.18499 26.5727 2.91113 26.3181 2.91113 26.0041C2.91113 25.6901 3.18499 25.4355 3.52343 25.4355H30.0025C30.3409 25.4355 30.6148 25.6901 30.6148 26.0041C30.6148 26.3181 30.3409 26.5727 30.0025 26.5727Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.0025 29.9477H3.52343C3.18499 29.9477 2.91113 29.6931 2.91113 29.3791C2.91113 29.0651 3.18499 28.8105 3.52343 28.8105H30.0025C30.3409 28.8105 30.6148 29.0651 30.6148 29.3791C30.6148 29.6931 30.3409 29.9477 30.0025 29.9477Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M30.0025 33.3217H3.52343C3.18499 33.3217 2.91113 33.0671 2.91113 32.7531C2.91113 32.4391 3.18499 32.1846 3.52343 32.1846H30.0025C30.3409 32.1846 30.6148 32.4391 30.6148 32.7531C30.6148 33.0671 30.3409 33.3217 30.0025 33.3217Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.0918 36.6955H3.52343C3.18499 36.6955 2.91113 36.4409 2.91113 36.1269C2.91113 35.8129 3.18499 35.5583 3.52343 35.5583H18.0918C18.4302 35.5583 18.7041 35.8129 18.7041 36.1269C18.7041 36.4409 18.4302 36.6955 18.0918 36.6955Z",
    fill: "#DBDBDB"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_6214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.6,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSvg);
export default __webpack_public_path__ + "static/media/ReportSvg.dd464859e1e832e70bf5f141bc44411f.svg";
export { ForwardRef as ReactComponent };